import type { IRequestOptions, IValidatedResponse } from '../../httpClient';
import { getRequest } from '../../httpClient';
import type { IGetSysGrammarPointV1Response } from './get-sys-grammar-point-v1-response';
import { getSysGrammarPointV1ResponseSchema } from './get-sys-grammar-point-v1-response';

export async function getSysGrammarPointV1(
  id: number,
  options?: IRequestOptions,
): Promise<IValidatedResponse<IGetSysGrammarPointV1Response>> {
  return getRequest<IGetSysGrammarPointV1Response>({
    path: `/sys/grammar/v1/points/${id}`,
    schema: getSysGrammarPointV1ResponseSchema,
    options,
  });
}
